<template>
  <div class="container">
    <slot />
  </div>
</template>
